// extracted by mini-css-extract-plugin
export default {"finishButton":"NQBDIB"};